export default __webpack_public_path__ + "static/media/399.018d7dd1.png";